import {ElementStatus, Elements, EditableKeys} from "@/types/theme";
import {snapshot} from "valtio";
import store from "@/store";

const getElementStatus = (
    id: string,
    type?: EditableKeys,
    val?: string
): ElementStatus => {
    const { selectedTheme } = snapshot(store);
    const { originalElements, currentElements } = selectedTheme;


    const originalItem = (() => {
        const { status, pinned, hints, ...rest } = originalElements.find(el => el.id === id) || {};
        return rest;
    })();


    const currentItem = (() => {
        const { status, pinned, hints, ...rest } = currentElements.find(el => el.id === id) || {};
        return rest as Partial<Elements>;
    })();


    if (val && type && currentItem) {
        const allowedKeys: Array<keyof Elements> = ["css", "jsx", "mobileCss", "tabletCss", "note"];
        if ((allowedKeys as string[]).includes(type)) {
            (currentItem as Partial<Record<keyof Elements, string>>)[type as keyof Elements] = val;
        }
    }


    if (originalItem) {
        if (JSON.stringify(originalItem) === JSON.stringify(currentItem)) {
            return "saved";
        } else {
            return "temporary";
        }
    } else {
        return "new";
    }
};


export default getElementStatus;